import { render, staticRenderFns } from "./VideoJSRecordMobile.vue?vue&type=template&id=6bb3f562&"
import script from "./VideoJSRecordMobile.vue?vue&type=script&lang=js&"
export * from "./VideoJSRecordMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports